var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c(
                  "c-table",
                  {
                    ref: "table",
                    attrs: {
                      title: "안전점검 결과 목록",
                      merge: _vm.grid.merge,
                      columns: _vm.grid.columns,
                      data: _vm.grid.data,
                      gridHeight: _vm.grid.height,
                      rowKey: "safetyCheckResultId",
                      editable: _vm.editable && !_vm.disabled,
                      columnSetting: false,
                      filtering: false,
                      usePaging: false,
                    },
                    on: { headLinkClick: _vm.headLinkClick },
                    scopedSlots: _vm._u([
                      {
                        key: "customArea",
                        fn: function ({ props, col }) {
                          return [
                            props.row[col.key] === "MSR0000001"
                              ? [
                                  _c("q-icon", {
                                    staticClass: "cursor-pointer",
                                    attrs: {
                                      name: "radio_button_unchecked",
                                      color: _vm.customColor(col, props.row),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openPop(col, props.row)
                                      },
                                    },
                                  }),
                                ]
                              : props.row[col.key] === "MSR0000002"
                              ? [
                                  _c("q-icon", {
                                    staticClass: "cursor-pointer",
                                    attrs: {
                                      name: "close",
                                      color: _vm.customColor(col, props.row),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openPop(col, props.row)
                                      },
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "template",
                      { slot: "suffixTitle" },
                      [
                        _c(
                          "font",
                          {
                            staticStyle: {
                              "font-size": "0.8em",
                              "font-weight": "300",
                            },
                          },
                          [
                            _c("q-chip", { attrs: { color: "green" } }),
                            _vm._v(" " + _vm._s("개선 건 없음") + " "),
                            _c("q-chip", { attrs: { color: "red" } }),
                            _vm._v(" " + _vm._s("개선 1건 이상") + " "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "template",
                      { slot: "prefixContent" },
                      [
                        !_vm.data.plantCd || !_vm.data.checkDate
                          ? _c("font", { attrs: { color: "#C10015" } }, [
                              _vm._v(" ※ 사업장 및 점검년월을 선택하세요. "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c(
            "c-dialog",
            {
              attrs: {
                param: _vm.popupOptions,
                returnData: { col1: _vm.data.safetyCheckId },
              },
            },
            [_vm._v(">")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }